import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import { fromMomentToZulu } from 'utils/converters/time/from.util';
import logger from 'utils/logger.util';

import {
  GET_BOOKING_HISTORY_FAILURE,
  GET_BOOKING_HISTORY_REQUEST,
  GET_BOOKING_HISTORY_SUCCESS,
} from 'clientProfile/constants';

const L = logger('getBookingHistory');

const PAGE_SIZE = `10`;

const getBookingHistory = (salonId, clientId, before) => {
  const isoBefore = fromMomentToZulu(before);
  const endpoint = `salon/v2/${salonId}/client/${clientId}/history/?before=${isoBefore}&page_size=${PAGE_SIZE}`;

  L[salonId && clientId ? 'debug' : 'warn']('()', { salonId, clientId }, { before, isoBefore }, 'endpoint:', endpoint);

  return {
    [AUTH_API]: {
      api_root: CONF.apiRoot,
      endpoint,
      authenticated: true,
      types: [GET_BOOKING_HISTORY_REQUEST, GET_BOOKING_HISTORY_SUCCESS, GET_BOOKING_HISTORY_FAILURE],
      params: { salonId, clientId, before, isoBefore },
    },
  };
};

// noinspection JSUnusedGlobalSymbols
export default getBookingHistory;
